import axios from "axios"
import urlUtils from "../utils/url"

export default async (firebaseToken) => {
  const url = urlUtils.getApiUrl("/api/public/firebase-login")

  const response = await axios({
    method: "post",
    url,
    headers: {
      "Content-Type": "application/json",
      accept: "*/*",
    },
    data: {
      firebase_token: firebaseToken,
    },
  })

  return response.data
}
